import { render } from "./ActualizarPasword.vue?vue&type=template&id=08a114e4"
import script from "./ActualizarPasword.vue?vue&type=script&lang=js"
export * from "./ActualizarPasword.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__